import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraLink, SpecraText } from '@mono/ui-components/ensigns';
import { SpecraKeyValueRow, SpecraSectionHeader } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { renderRouterLink } from '../../../../lib/renderRouterLink';
import { registryHref } from '../../registryHref';
import { evaluationStyleText } from './evaluationStyleText';
export function WhatTheyAskFor({ dossier: d }) {
    return /*#__PURE__*/ _jsxs("section", {
        className: "space-y-3",
        children: [
            /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                variant: "group",
                title: "What they ask for"
            }),
            d.asks.length === 0 && /*#__PURE__*/ _jsx(SpecraText, {
                as: "p",
                size: "body-ui",
                tone: "muted",
                children: "No solicitation patterns recorded yet."
            }),
            d.asks.map((a, i)=>/*#__PURE__*/ _jsx(SpecraKeyValueRow, {
                    "data-testid": Testids.registryGovOrg.askRow,
                    label: a.anchor ? /*#__PURE__*/ _jsx(SpecraLink, {
                        href: registryHref(a.anchor) ?? undefined,
                        renderLink: renderRouterLink,
                        children: a.anchor.name
                    }) : 'Labor category',
                    value: `${a.solicitationCount} solicitations since ${a.sinceYear}${a.trend === 'RISING' && a.trendSinceYear ? ` · rising since ${a.trendSinceYear}` : ''}`
                }, a.anchor?.id || i)),
            d.evaluationStyle && /*#__PURE__*/ _jsxs("div", {
                "data-testid": Testids.registryGovOrg.evaluationStyle,
                children: [
                    /*#__PURE__*/ _jsx(SpecraKeyValueRow, {
                        variant: "fact",
                        label: "Evaluation style",
                        value: evaluationStyleText(d.evaluationStyle)
                    }),
                    /*#__PURE__*/ _jsx(SpecraText, {
                        as: "p",
                        size: "meta",
                        tone: "muted",
                        children: d.evaluationStyle.sourceNote
                    })
                ]
            })
        ]
    });
}
